module.exports = __webpack_public_path__ + "img/picture.25b22228.png";